let API_BASE = 'https://api.clomp.io/api';

// OAuth client id for Sign in with Google. Set REACT_APP_GOOGLE_CLIENT_ID (e.g. in frontend/.env.local); the Google
// button is hidden when it's missing.
let GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

export { API_BASE, GOOGLE_CLIENT_ID }
